export const colors = {
  primary: '#25A376',
  primaryActive: '#189F70',
  primaryLight: '#d9fdf1',
  primaryLightDark: '#212E48',
  primaryInverse: '#ffffff',
}